import fs from 'node:fs';
import path from 'node:path';
import os from 'node:os';

export interface RepoConfig {
  name: string;
  url: string;
  type: 'gitee' | 'gitea';
  token?: string;
  username?: string;
  password?: string;
}

export interface RemoteMergeHistory {
  sourceRepo: string;
  sourceBranch: string;
  targetRepo: string;
  targetBranch: string;
  options: {
    showDiff?: boolean;
    conflictStrategy?: 'ours' | 'theirs';
    push?: boolean;
  };
  timestamp: number;
}

export class ConfigManager {
  private configPath: string;
  private config: { repos: RepoConfig[]; remoteMergeHistory?: RemoteMergeHistory };

  constructor() {
    this.configPath = path.join(os.homedir(), '.supos-git-config.json');
    this.config = this.loadConfig();
  }

  private loadConfig(): { repos: RepoConfig[]; remoteMergeHistory?: RemoteMergeHistory } {
    try {
      if (fs.existsSync(this.configPath)) {
        const content = fs.readFileSync(this.configPath, 'utf-8');
        return JSON.parse(content);
      }
    } catch (error) {
      console.error('加载配置文件失败:', error);
    }
    return { repos: [] };
  }

  private saveConfig(): void {
    try {
      fs.writeFileSync(this.configPath, JSON.stringify(this.config, null, 2));
    } catch (error: any) {
      throw new Error(`保存配置文件失败: ${error.message}`);
    }
  }

  addRepo(repo: RepoConfig): void {
    const existingIndex = this.config.repos.findIndex((r) => r.name === repo.name);
    if (existingIndex >= 0) {
      this.config.repos[existingIndex] = repo;
    } else {
      this.config.repos.push(repo);
    }
    this.saveConfig();
  }

  getRepo(name: string): RepoConfig | undefined {
    return this.config.repos.find((repo) => repo.name === name);
  }

  removeRepo(name: string): void {
    this.config.repos = this.config.repos.filter((repo) => repo.name !== name);
    this.saveConfig();
  }

  listRepos(): RepoConfig[] {
    return this.config.repos;
  }

  /**
   * 保存远程合并历史记录
   * @param history 远程合并历史记录
   */
  saveRemoteMergeHistory(history: RemoteMergeHistory): void {
    this.config.remoteMergeHistory = history;
    this.saveConfig();
  }

  /**
   * 获取远程合并历史记录
   * @returns 远程合并历史记录，如果不存在则返回undefined
   */
  getRemoteMergeHistory(): RemoteMergeHistory | undefined {
    return this.config.remoteMergeHistory;
  }
}
